import moment from "moment";
import React, {useState} from "react";
import { useTable, useSortBy } from "react-table";
// import "./Leads.scss";
import CaseResponseModel from "../../models/Cases/CaseResponseModel";
import { faSortDown, faSortUp, faUnsorted } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Navigate } from "react-router-dom";



interface LeadTrackerListProps {
  CasesData: Array<CaseResponseModel>;
  getCasesByOrgWithSorting: (sortColumn: string, SortDorection: string) => void;
  oppotuntiesOrNot:boolean
}
const CaseTrackerList = (props: LeadTrackerListProps) => {
  const [showLeadDetails, setShowLeadDetails] = useState<boolean>(false);
  const [caseId, setCaseId] = useState<any>("");

  const leadDetailsHandler = (rowData:any) => {
    const case_code = rowData.original.caseId
    const case_id = props.CasesData.find((m:any)=>m.caseCode === case_code)?.caseId
    setCaseId(case_id);
    setShowLeadDetails(true);
  }

  const data: any[] =  React.useMemo(() =>{
    const items =  props.CasesData.map((Case: CaseResponseModel) =>({
        caseCategory: "Special",
        caseId: Case.caseCode,
        caseTitle: Case.title,
        caseManager: Case.caseManager,
        customer: Case.companyName !== null ? Case.companyName :Case.caseType,
        startDate: moment(Case.createdDate).format("MM/DD/YY"),
        dueDate: moment(Case.dueDate).format("MM/DD/YY"),
        status: Case.status,
        daysInStatus: Math.abs(Case.daysInStatus),
        daysRemaining: Math.abs(Case.dueDays),
      })
    );
    return items;
  },[props.CasesData]);
   
  
  const columns: any = React.useMemo(
    () => [
      {
        Header: "Case Category",
        accessor: "caseCategory", // accessor is the "key" in the data
      },
      {
        Header: "Case ID ",
        accessor: "caseId",
      },
      {
        Header: "Case Title",
        accessor: "caseTitle",
      },
      {
        Header: "Case Manager",
        accessor: "caseManager",
      },
      {
        Header: 'Customer',
        accessor: 'customer',
      },
      {
        Header: "Start Date",
        accessor: "startDate",
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Days in Status",
        accessor: "daysInStatus",
      },
      {
        Header: "Days Remaining",
        accessor: "daysRemaining",
      },
      


    ],
    []
  ); 
  const getSortValues = (column:any) => {
    let sortColumn="";
    let SortDorection ="";
    if(column.isSorted == true){
      sortColumn = columns.find((each: any) => each.Header == column.Header)?.accessor;
    }
    if(column.isSortedDesc != null){
      SortDorection=column.isSortedDesc?"ASC":"DESC"; 
    }
    props.getCasesByOrgWithSorting(sortColumn,SortDorection);
    
  }
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data, manualSortBy: true }, useSortBy);
 
  return (
   <>
   {showLeadDetails &&
        <Navigate to={`/caseTracker/details/${caseId}`} />
     }
    <div className="listViewWrap">      
      <table {...getTableProps()} className="listViewTable">
        <thead>
          {headerGroups.map((headerGroup: any, index: number) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column: any, columnIndex: number) => (
                <th
                  key={columnIndex}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    background: "aliceblue",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                    <div className="sortnigColumnDiv" onClick={()=>setTimeout(()=>{getSortValues(column)},10)}>
                    <span className="pointer-cursor" >{column.render("Header")}   </span>
                    <span><FontAwesomeIcon icon={faUnsorted} />
                    {column?.isSorted ? column?.isSortedDesc
                        ? 
                        <FontAwesomeIcon icon={faSortUp} />
                        : 
                        <FontAwesomeIcon icon={faSortDown} />
                      : "" }
                  </span> 
                    </div>               
                
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row: any, rowIndex: number) => {
            prepareRow(row);
            return (
              <tr 
                key={rowIndex}
                {...row.getRowProps()} onClick={()=>leadDetailsHandler(row)} 
                className="listRow"
              >
                {row.cells.map((cell: any, rowCellsIndex: number) => {
                  return (
                    <td
                      key={rowCellsIndex}
                      {...cell.getCellProps()}
                      style={{
                        padding: "10px",
                        border: "solid 1px gray",
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    </>
  );
};

export default CaseTrackerList;
